/**
 * The Lexical theme LexicalRichEditor mounts with — every class the editor
 * stamps on its DOM (and therefore what LexicalRichEditor.css styles).
 *
 * Its own module for the same reason as tableDefaults.js: tests must assert
 * against THE REAL theme (the checklist round-trip in particular renders with
 * it), and importing LexicalRichEditor.js into jest drags OsScroll's bare
 * node_modules .css import along.
 */
export const THEME = {
  paragraph: 'lx-p',
  quote: 'lx-quote',
  heading: { h1: 'lx-h1', h2: 'lx-h2', h3: 'lx-h3' },
  list: {
    ul: 'lx-ul', ol: 'lx-ol', listitem: 'lx-li',
    nested: { listitem: 'lx-nested-li' },
    // To-do lists: @lexical/list adds `checklist` on the <ul> and swaps the
    // checked/unchecked class per item as CheckListPlugin toggles them.
    checklist: 'lx-checklist',
    listitemChecked: 'lx-li-checked',
    listitemUnchecked: 'lx-li-unchecked',
  },
  link: 'lx-link',
  // PageLinkNode's decorator host element (the chip itself is styled by
  // PageLinkComponent's own classes; this makes the host render as a block).
  pageLink: 'lx-page-link-block',
  // Doc media decorator hosts (DocImageNode / DocVideoEmbedNode) — same role
  // as pageLink: the host renders as a block, the component styles itself.
  docImage: 'lx-doc-image-block',
  docVideo: 'lx-doc-video-block',
  // CalloutNode (lexicalNodes/CalloutNode.js); its kind adds `lx-callout--<kind>`.
  callout: 'lx-callout',
  table: 'lx-table',
  tableRow: 'lx-table-row',
  tableCell: 'lx-table-cell',
  tableCellHeader: 'lx-table-cell-header',
  text: {
    bold: 'lx-bold', italic: 'lx-italic', underline: 'lx-underline',
    strikethrough: 'lx-strike', underlineStrikethrough: 'lx-underline-strike',
    code: 'lx-inline-code',
  },
  code: 'lx-code',
  codeHighlight: {
    atrule: 'token atrule', attr: 'token attr', boolean: 'token boolean',
    builtin: 'token builtin', cdata: 'token cdata', char: 'token char',
    class: 'token class', 'class-name': 'token class-name', comment: 'token comment',
    constant: 'token constant', deleted: 'token deleted', doctype: 'token doctype',
    entity: 'token entity', function: 'token function', important: 'token important',
    inserted: 'token inserted', keyword: 'token keyword', namespace: 'token namespace',
    number: 'token number', operator: 'token operator', prolog: 'token prolog',
    property: 'token property', punctuation: 'token punctuation', regex: 'token regex',
    selector: 'token selector', string: 'token string', symbol: 'token symbol',
    tag: 'token tag', url: 'token url', variable: 'token variable',
  },
};
